import {
  GET_ASSESSMENT_SUMMARY,
  FETCH_ASSESSMENT_SUMMARY_ERROR,
  FETCH_ASSESSMENT_SUMMARY_START,
  FETCH_ASSESSMENT_SUMMARY_SUCCESS,
} from './types';
import { AssessmentSummaryPayload } from 'types/assessment-payload';

export const ERROR_MESSAGE =
  'Error happened while loading, try reloading the page';

interface IFetchAssessmentSummaryAction {
  type: typeof GET_ASSESSMENT_SUMMARY;
  token: string;
}

export interface IFetchAssessmentSummaryStart {
  type: typeof FETCH_ASSESSMENT_SUMMARY_START;
}

export interface IFetchAssessmentSummarySuccess {
  type: typeof FETCH_ASSESSMENT_SUMMARY_SUCCESS;
  summary: AssessmentSummaryPayload;
}

export interface IFetchAssessmentSummaryError {
  type: typeof FETCH_ASSESSMENT_SUMMARY_ERROR;
  error: {
    message: string;
    statusCode: number;
  };
}

export function fetchAssessmentSummaryAction(
  token: string
): IFetchAssessmentSummaryAction {
  return {
    type: GET_ASSESSMENT_SUMMARY,
    token,
  };
}

export function fetchAssSummaryStartAction(): IFetchAssessmentSummaryStart {
  return {
    type: FETCH_ASSESSMENT_SUMMARY_START,
  };
}

export function fetchAssessmentSummarySuccessAction(
  summary: AssessmentSummaryPayload
): IFetchAssessmentSummarySuccess {
  return {
    type: FETCH_ASSESSMENT_SUMMARY_SUCCESS,
    summary,
  };
}

export function fetchAssessmentSummaryErrorAction(
  message = ERROR_MESSAGE,
  statusCode: number
): IFetchAssessmentSummaryError {
  return {
    type: FETCH_ASSESSMENT_SUMMARY_ERROR,
    error: {
      message,
      statusCode,
    },
  };
}
